import { PageLayout } from '@ferreri/prever-component-lib/nextjs';
import { PlanDetails } from '../../modules/plan-details/PlanDetails';
import { PAGE_TITLE } from '../../utils/pageTitle';
import { useCurrentPlanVersionManifest } from '../../modules/admin/plan-versions/plan-version.store';

export default function PlanDetailsPage() {
  const { data: planVersion } = useCurrentPlanVersionManifest();

  return (
    <PageLayout
      title={PAGE_TITLE.details(planVersion?.plan_distribution?.plan?.name)}
    >
      <PlanDetails />
    </PageLayout>
  );
}
